import * as React from "react"

// Styles

const Sidebar: React.FC = ({ children }) => {
  return <aside className={"sidebar"}>{children}</aside>
}

export default Sidebar
